// test1971
(1971 && 0);
